import { connect } from 'react-redux';

import { StoreState } from '../../../../reducers';
import Row from '../../../../components/ProposalStatsPage/Table/Row';
import DriveItemUtils from '../../../../utils/driveItem';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		proposalStats: { proposalStatus, byId },
	} = state;
	const {
		type,
		fileType,
		format,
		label,
		recipientEmail,
		readsNbr,
		downloads,
		sendingDate,
		openingDate,
		relUrl,
	} = byId[ownProps.id];

	return {
		proposalStatus,
		type,
		fileType,
		isProposal: DriveItemUtils.isProposal(format),
		label,
		recipientEmail,
		readsNbr,
		downloads,
		sendingDate,
		openingDate,
		relUrl,
	};
};

export default connect(mapStateToProps)(Row);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ProposalStatsPage/Table/Row/index.tsx